import createIcon from '../../createIcon';

/**
 * @component @name ArrowDropDown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyA5LjVMMTIgMTQuNUwxNyA5LjVIN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArrowDropDown = createIcon('ArrowDropDown', [
  ['path', { d: 'M7 9.5L12 14.5L17 9.5H7Z', key: 'ocirk0' }],
]);

export default ArrowDropDown;
